<template>
  <div>
    <el-button type="warning">
      <div class="feather">
        <img class="feather-img" src="@/assets/images/iconadd.png" />
        <div>
          <div>
            <slot name="title"></slot>
          </div>
        </div>
      </div>
    </el-button>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.el-button {
  background-color: #3c8dbc;
  font-size: 18px;
}
.feather {
  display: flex;
  align-items: center;
}
.feather-img {
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
</style>